import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M4.61909 11.6085C3.35698 11.0475 3.45956 9.2233 4.7766 8.80739L17.2493 4.86865C18.4072 4.503 19.497 5.59284 19.1314 6.75072L15.1926 19.2234C14.7767 20.5404 12.9525 20.643 12.3915 19.3809L10.3124 14.7029C10.1113 14.2505 9.74953 13.8887 9.29707 13.6876L4.61909 11.6085Z',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const DirectionAlternativeOutlined = React.forwardRef(IconComponent);
DirectionAlternativeOutlined.displayName = 'DirectionAlternativeOutlined';

export { DirectionAlternativeOutlined };
